module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pback3-adea461058aa23757e910ce9d0926ba2.jpg";